import { FaroChip, grey, orange } from "@faro-lotv/flat-ui";
import type { JSX } from "react";

type BetaBadgeProps = {
  /** Whether dark mode styles should be applied. @default false */
  dark?: boolean;
};

/**
 * @returns a red chips to indicate that the feature is in beta
 */
export function BetaBadge({ dark }: BetaBadgeProps): JSX.Element {
  return <CustomBadge badgeText="BETA" dark={dark} />;
}

type CustomBadgeProps = {
  /** text on custom badge */
  badgeText: string;

  /** Whether dark mode styles should be applied. @default false */
  dark?: boolean;
};

/**
 * @returns a red chips to with badge containing custom text
 */
function CustomBadge({ badgeText, dark }: CustomBadgeProps): JSX.Element {
  return (
    <FaroChip
      label={badgeText}
      color={dark ? grey[950] : grey[100]}
      backgroundColor={orange[500]}
    />
  );
}
